export const message = {
  requestFailure:'請求數據失敗',
  pleaseSelect:'請選擇',
  pleaseInput:'請輸入',
  pleaseEnterAgain:'請再次輸入',
  cancel:'取消',
  confirm:'確定',
  tips:'提示',
  changePassword:'修改密碼',
  originalPassword:'原密碼',
  newPassword:'新密碼',
  confirmPassword:'確認密碼',
  noData:'暫無數據',
  toAudited:'待審核',
  toShipped:'待發貨',
  receivable:'待收款',
  dateTime:'日期',
  orderNumber:'訂單數',
  orderAmount:'訂單額',
  singular:'單數',
  amountMoney:'金額',
  yes:'是',
  no:'否',
  chooseNcode:'請選擇區號',
  chooseGoods:'請選擇商品',
  chooseOrder:'請選擇訂單',
  chooseCustomer:'請選擇客户',
  examine:'審核',
  delete:'刪除',
  outStock:'出庫',
  receivables:'收款',
  printing:'打印',
  merge:'合併',
  printNow:'立即打印',
  operation:'操作',
  see:'查看',
  allElection:'全選',
  query:'查詢',
  empty:'清空',
  newlyBuild:'新建',
  edit:'編輯',
  batchImport:'批量導入',
  export:'導出',
  goodsNameBarCode:'商品名稱或條碼',
  brand:'品牌',
  class:'分類',
  subclass:'子分類',
  state:'狀態',
  upperShelf:'上架',
  lowerShelf:'下架',
  inventory:'盤點中',
  batchDownShelf:'批量下架',
  batchDeletion:'批量刪除',
  itemNumber:'貨號',
  store:'店倉',
  goodsStatus:'商品狀態',
  stockStatus:'庫存狀態',
  inStock:'有貨',
  noGoods:'無貨',
  orderNum:'訂單號',
  orderStatus:'訂單狀態',
  pendingPayment:'待付款',
  shipped:'已發貨',
  completed:'已完成',
  cancelled:'已取消',
  invalid:'已作廢',
  receivabless:'已收款',
  paymentStatus:'付款狀態',
  startDate:'開始日期',
  endDate:'結束日期',
  customerName:'客户名稱',
  salesperson:'銷售員',
  orderSource:'訂單來源',
  valetOrder:'代客下單',
  salesmenOrders:'業務員下單',
  weChatShop:'微信店鋪',
  effective:'有效',
  invalids:'無效',
  goodsPictures:'商品圖片',
  numberBarCode:'貨號 / 條碼',
  goodsName:'商品名稱',
  spec:'規格',
  company:'單位',
  unitPriceSales:'銷售單價',
  costUnitPrice:'成本單價',
  availableStock:'可售庫存',
  returnStock:'退貨庫存',
  salesInventory:'銷售庫存',
  downloadTemplate:'下載模板',
  drag:'將文件拖到此處，或',
  clickUpload:'點擊上傳',
  uploadFailure:'上傳失敗',
  uploadXLS:'上傳文件只能是 xls 格式!',
  orderTime:'下單時間',
  orderAmounts:'訂單金額',
  amountReceived:'已收金額',
  barcodeGeneration:'生成條碼',
  goodsInformation:'商品信息',
  goodsClassification:'商品分類',
  goodsBrand:'商品品牌',
  mainUnit:'主單位',
  auxiliaryUnit:'輔單位',
  quaranteeQuality:'保質期',
  day:'天',
  month:'月',
  upperChannel:'上架渠道',
  microMall:'微店铺',
  jieldOperations:'外勤業務端',
  specificationSet:'規格設置',
  singleSpec:'單規格',
  multiSpec:'多規格',
  formName:'規格名稱',
  attributeName:'屬性名稱',
  displayMap:'展示圖',
  barCode:'條碼',
  costPrice:'成本價',
  sellingPrice:'銷售價',
  goodsPrice:'商品價格',
  retailPrice:'零售價',
  ladderPrice:'批發階梯價',
  retailDescribe:'零售單位默認對應輔單位，若未設置輔單位，零售單位默認為主單位。需使用收銀功能的商品必須填寫零售價',
  ladderDescribe:'批發單位默認對應主單位。需使用訂單功能的商品必須填寫批發價',
  startingQuantity:'起訂量',
  goodsDetails:'商品詳情',
  detailMap:'詳情圖',
  describe:'描述',
  settingPoints:'提點設置',
  pointType:'提點類型',
  nothing:'無',
  inProportion:'按比例',
  accordingQuantity:'按量',
  pointValue:'提點值',
  eachStroke:'每筆',
  save:'保存',
  return:'返回',
  newAttribute:'新增屬性',
  enterNameProduct:'請輸入商品名稱',
  chooseGoodsClassification:'請選擇商品分類',
  selectGoodsUnits:'請選擇商品單位',
  chooseBrandGoods:'請選擇商品品牌',
  selectStatus:'請選擇狀態',
  enterPropertyName:'請輸入屬性名稱',
  specCannotRepeated:'規格不能重複',
  superiorStartingQuantity:'不能小於上級起訂量',
  salesPriceSuperiorLevel:'不能大於上級銷售價',
  uploadUpPictures:'最多上傳9張圖片',
  uploadHeadPictureFormat:'上傳頭像圖片只能是 JPG 或 PNG 格式!',
  uploadHeadImageSize:'上傳頭像圖片大小不能超過 1MB!',
  firstLadderPriceCannotEmpty:'第一階梯價不能為空',
  attribute:'屬性',
  brandName:'品牌名稱',
  newBrand:'新建品牌',
  editBrand:'編輯品牌',
  enterBrandName:'請輸入品牌名稱',
  chooseBrand:'請選擇品牌',
  classificationName:'分類名稱',
  subcategoryName:'子分類名稱',
  adSubcategories:'添加子分類',
  batchDeleSubclass:'批量刪除子分類',
  newClass:'新建分類',
  superiorCategoryName:'上級分類名稱',
  editCass:'編輯分類',
  enterCategoryName:'請輸入分類名稱',
  selectSubcategories:'請選擇子分類',
  stockEarlyWarning:'庫存預警',
  upperLimit:'上限',
  lowerLimit:'下限',
  colorName:'顏色名稱',
  sizeName:'尺碼名稱',
  commodityLadderPrice:'商品階梯價',
  chooseLeastColorSize:'請至少選擇一個顏色或尺碼',
  addAttribute:'添加屬性',
  batchDeleteSpecification:'批量刪除規格',
  batchDeletionAttributes:'批量刪除屬性',
  newSpecifications:'新建規格',
  editSpecification:'編輯規格',
  editAttribute:'編輯屬性',
  enterSpecName:'請輸入規格名稱',
  attributeCannotEmpty:'屬性不能為空',
  selectSpec:'請選擇規格',
  selectAttributes:'請選擇屬性',
  remainingShelfLifeDays:'剩餘保質期天數',
  frozenStock:'凍結庫存',
  dateStorage:'入庫日期',
  dateManufacture:'生產日期',
  enterRemainingShelfLifeDays:'請輸入剩餘保質期天數',
  unitName:'單位名稱',
  newUnit:'新建單位',
  editUnit:'編輯單位',
  enterNameUnit:'請輸入單位名稱',
  selectUnit:'請選擇單位',
  nearlyQiDays:'近7天',
  nearlySanShidays:'近30天',
  nearlyJiuShiDays:'近90天',
  totalAmount:'金額合計',
  amountCollected:'待收金額',
  preferentialAmount:'優惠金額',
  generationIcon:'【代】',
  tradeIcon:'【業】',
  storeIcon:'【店】',
  batchOperation:'批量操作',
  purchasing:'加入採購',
  fullParticipation:'全部加入採購',
  requirement:'需求量',
  allGoodsPurchased:'商品已全部加入採購',
  boss:'老闆',
  inside:'內勤',
  cashiers:'收銀員',
  salesman:'業務員',
  customerInformation:'客户信息',
  distributionMode:'配送方式',
  num:'數量',
  unitPrice:'單價',
  subtotal:'小計',
  remarks:'備註',
  tradePrice:'批發價',
  lastUnitPrice:'上次成交單價',
  discountRate:'折扣率',
  concessionTotal:'優惠合計',
  discountAmount:'折扣額',
  totalOrders:'訂單總額',
  selectCustomerName:'請選擇客户名稱',
  total:'合計',
  discountPleaseEnter:'如8折請輸入80',
  receivingAddress:'收貨地址',
  discountAmounts:'折扣金額',
  commodityAmount:'商品金額',
  freightAmount:'運費金額',
  depositDeliveryRecords:'出庫/發貨記錄',
  outgoingNumber:'出庫單號',
  outgoingTime:'出庫時間',
  personCharge:'經辦人',
  brandCommodityNameSpec:'品牌 / 商品名稱 / 規格',
  outVolume:'出庫量',
  collectionRecords:'收款記錄',
  amountPayable:'應付金額',
  unpaidAmount:'未付金額',
  amountPaid:'已付金額',
  collectionTime:'收款時間',
  amountCollecteds:'收款金額',
  receipts:'收款備註',
  toVoid:'作廢',
  orderRemark:'訂單備註',
  buyerMessage:'買方留言',
  ccrapOrder:'作廢訂貨單',
  chooseTimeCollection:'請選擇收款時間',
  enterAmountReceipt:'請輸入收款金額',
  paymentTime:'付款時間',
  paymentAmount:'付款金額',
  operator:'操作人',
  invalidDescription:'單據作廢將撤銷相應的庫存、賬務，且作廢後數據不可恢復，作廢?',
  cancellationNum:'退單號',
  returningWarehouse:'退貨入庫方式',
  returnReason:'退貨原因',
  packageBreakage:'包裝破損',
  qualityProblem:'質量問題',
  onSchedule:'臨期',
  refundAmount:'退款金額',
  confirmationStatement:'確認説明',
  confirmationTime:'確認時間',
  confirmingPerson:'確認人',
  wasteReturnBill:'作廢退貨單',
  changeNum:'換單號',
  pendingProcessing:'待換處理',
  repair:'【補】',
  retreat:'【退】',
  chooseGoodsReturned:'請選擇退貨商品',
  chooseGoodsExchange:'請選擇換貨商品',
  returnedGoods:'退貨商品列表',
  exchangeList:'換貨商品列表',
  exportInventoryTemplate:'導出庫存模板',
  storageTemplate:'入庫模板',
  inventoryTemplate:'盤點模板',
  totalInventoryAmount:'庫存總金額',
  tightStock:'庫存緊張',
  stockAmount:'庫存金額',
  warningValue:'預警值',
  settingWarningValue:'設置庫存預警值',
  enterWarningValue:'請輸入預警值',
  businessOddNum:'業務單號',
  type:'類型',
  stockUnit:'庫存單位',
  dateChange:'變更日期',
  nameStore:'店倉名稱',
  changeType:'變更類型',
  operationType:'操作類型',
  amountChange:'變更量',
  currentInventory:'當前庫存',
  warehousing:'入庫',
  purchaseWarehousing:'採購入庫',
  returnStorage:'退貨入庫',
  returnWarehouse:'退貨入銷庫',
  returnWarehouses:'退貨入退庫',
  otherWarehousing:'其他入庫',
  transferWarehouses:'調貨入庫',
  salesOutlet:'銷售出庫',
  returnOutStock:'退貨出庫',
  exchangeOutStock:'換貨出庫',
  otherOutlets:'其他出庫',
  transferOutStock:'調貨出庫',
  inventorys:'盤點',
  inventorySale:'盤點平賬(售)',
  inventoryRefund:'盤點平賬(退)',
  warehouseReceipt:'入庫單號',
  storageType:'入庫類型',
  businessSingleNum:'關聯業務單號',
  warehousingTime:'入庫時間',
  selectWarehouseReceipt:'請選擇入庫單',
  unitPriceWarehousingCost:'上次入庫成本單價',
  selectTypeStorage:'請選擇入庫類型',
  selectStorageTime:'請選擇入庫時間',
  auditTime:'審核時間',
  auditor:'審核人',
  scheduledReceipt:'入庫量',
  outgoingSingleNum:'出庫單號',
  outgoingType:'出庫類型',
  selectOutReceipt:'請選擇出庫單',
  selectTypeLibraryExit:'請選擇出庫類型',
  chooseTimeLeaveWarehouse:'請選擇出庫時間',
  warehousesCanSame:'調出倉庫與調入倉庫不能相同',
  allocationOddNum:'調撥單號',
  transferWarehouse:'調出倉庫',
  transferWarehousess:'調入倉庫',
  transferAudit:'調入審核',
  dismissal:'調入駁回',
  auditOut:'調出審核',
  dismissals:'調出駁回',
  outStocks:'待出庫',
  pendingStorage:'待入庫',
  allocationTime:'調撥時間',
  selectTransferOrder:'請選擇調撥單',
  chooseTransferOutWarehouse:'請選擇調出倉庫',
  chooseTransferWarehouse:'請選擇調入倉庫',
  transferVolume:'調貨量',
  reject:'駁回',
  checkOddNum:'盤點單號',
  inventoryTime:'盤點時間',
  actualInventory:'實際庫存',
  sell:'【售】',
  selectInventoryTime:'請選擇盤點時間',
  enterCorrectNumber:'請輸入一個正確的數字',
  enterProductNameBarCode:'輸入商品名稱或條碼',
  batchSelection:'批量選擇',
  shortage:'缺貨',
  pleaseChooseCommodity:'請選擇一個商品',
  exportCommodities:'導出商品',
  purchaseOrderNum:'採購單號',
  warehouse:'倉庫',
  procurementTime:'採購時間',
  selectPurchaseOrder:'請選擇採購單',
  selectWarehouse:'請選擇倉庫',
  purchaseVolume:'採購量',
  bulkPurchase:'批量採購',
  demandInventory:'需求庫存',
  customerType:'客户類型',
  microshopSalesman:'微店業務員',
  areaGrouping:'區域分組',
  priceGroupings:'價格分組',
  newClient:'新建客户',
  contacts:'聯繫人',
  contactNumber:'聯繫電話',
  location:'所在區域',
  province:'省',
  city:'市',
  area:'區',
  detailedAddress:'詳細地址',
  editClient:'編輯客户',
  customerSalesmanGrouping:'設置客户業務員',
  customerAreaGrouping:'設置客户區域分組',
  customerPriceGrouping:'設置客户價格分組',
  enterCustomerName:'請輸入客户名稱',
  selectCustomerType:'請選擇客户類型',
  enterContactNumber:'請輸入聯繫電話',
  selectArea:'請選擇區域',
  enterDetailedAddress:'請輸入詳細地址',
  selectSalesman:'請選擇業務員',
  selectRegionalGrouping:'請選擇區域分組',
  selectPriceGroup:'請選擇價格分組',
  auditCustomers:'審核客户',
  confirmationPassed:'確認通過?',
  refuse:'拒絕',
  adopt:'通過',
  customerTypeName:'客户類型名稱',
  newCustomerType:'新建客户類型',
  typeName:'類型名稱',
  editingCustomerType:'編輯客户類型',
  enterTypeName:'請輸入類型名稱',
  selectTheType:'請選擇類型',
  groupName:'分组名称',
  enterContent:'请输入内容',
  regionalGroupingName:'區域分組名稱',
  newRegionalGrouping:'新建區域分組',
  editAreaGrouping:'編輯區域分組',
  enterGroupName:'請輸入分組名稱',
  customerNumber:'客户數',
  salesAmount:'銷售金額',
  preferentialWayt:'優惠方式',
  preferentialAmountt:'優惠金額',
  notCountSmallChanget:'抹零',
  amountReceivablet:'應收金額',
  amountReceivedt:'實收金額',
  preferentialDiscountSettings:'優惠折扣設置',
  open:'開',
  shut:'關',
  wholeSingleDiscount:'整單折扣',
  discountPleaseEnters:'如8折,請輸入8',
  clickEnterSave:'點擊回車保存',
  wholeSingleVerticalReduction:'整單立減',
  wipeSettings:'抹零設置',
  wayPolishing:'抹零方式',
  wipePoints:'抹分',
  makeTurn:'抹角',
  rounding:'四捨五入',
  totalCashCollection:'收銀總額',
  cash:'現金',
  alipay:'支付寶',
  weChat:'微信',
  inputRemarks:'輸入備註',
  printSmallTicket:'打印小票',
  preferentialTreatment:'選擇優惠',
  enterNameNumBarcodeProduct:'請輸入商品名稱、貨號、條碼',
  aggregateQuantity:'合計數量',
  totalSum:'合計金額',
  confirmOrder:'確定下單',
  changeAmount:'找零金額',
  confirmPayment:'確定付款',
  pleaseScanningGunScanPayment:'請使用掃描槍掃描顧客手機上的付款碼',
  paymentAmounts:'支付金額',
  enterAmountPaid:'請輸入實收金額',
  relatedCommodities:'沒有相關的商品',
  chooseLeastOneItem:'請至少選擇一個商品',
  chooseStore:'請選擇店倉',
  salesmanInformation:'業務員信息',
  sissionAccomplishmentDuringMonth:'當月任務完成情況',
  todayPerformance:'今日業績',
  fullName:'姓名',
  aTurnover:'交易額',
  royalty:'提成',
  returnGoods:'退貨',
  newCustomer:'新客',
  visit:'拜訪',
  newSalesman:'新建業務員',
  salesmanName:'業務員姓名',
  region:'區域',
  editSalesman:'編輯業務員',
  normal:'正常',
  prohibit:'禁用',
  enterYourName:'請輸入姓名',
  enterYourAccountNumber:'請輸入賬號',
  inputPassword:'請輸入密碼',
  minimumBitsMaximumBits:'最少8位，最大16位',
  months:'月份',
  taskInformation:'任務信息',
  title:'標題',
  term:'期限',
  taskAccomplishment:'任務完成情況',
  taskTitle:'任務標題',
  naturalMonth:'自然月',
  january:'一月',
  february:'二月',
  march:'三月',
  april:'四月',
  may:'五月',
  june:'六月',
  july:'七月',
  august:'八月',
  september:'九月',
  october:'十月',
  november:'十一月',
  december:'十二月',
  missionDeadline:'任務期限',
  selectionTime:'選擇時間',
  dateRange:'日期範圍',
  enterTaskTitle:'請輸入任務標題',
  chooseNaturalMonth:'請選擇自然月',
  selectDurationTask:'請選擇任務期限',
  enterTransactionAmount:'請輸入交易額',
  numberCurrentOrders:'當前訂單數',
  completedTransactionVolume:'已完成交易額',
  currentRoyalty:'當前提成',
  repetitionMode:'重複方式',
  repetitionTime:'重複時間',
  taskLine:'任務線路',
  lineRules:'線路規則',
  byRegion:'按區域',
  byCustomer:'按客户',
  never:'從不',
  daily:'每天',
  weekly:'每週',
  monthly:'每月',
  monday:'週一',
  tuesday:'週二',
  wednesday:'週三',
  thursday:'週四',
  sriday:'週五',
  saturday:'週六',
  sunday:'週日',
  lineInformation:'線路信息',
  selectRouteRule:'請選擇線路規則',
  chooseRepetitionMode:'請選擇重複方式',
  chooseRepetitionTime:'請選擇重複時間',
  numNewCustomers:'新增客户數',
  numVisitors:'拜訪客户數',
  numSubscribers:'下單客户數',
  dateCheck:'簽到日期',
  signDetails:'簽到詳情',
  taskCompletionRate:'任務完成率',
  signAddress:'簽到地址',
  consultMap:'查看地圖',
  attendanceStatus:'簽到情況',
  customerAddress:'客户地址',
  hangAir:'未完成',
  checkTime:'簽到時間',
  signingTime:'簽退時間',
  residenceTime:'停留時間',
  address:'地址',
  visitingTasks:'拜访任务量',
  actualVisits:'实际拜访量',
  unvisitedVolume:'未拜访量',
  dateReporting:'上報日期',
  displayArea:'陳列面積',
  picture:'圖片',
  addressSubmitted:'上報地址',
  inventoryss:'庫存量',
  newType:'新建類型',
  editType:'編輯類型',
  selectTypeAccount:'請選擇賬目類型',
  retailIncome:'零售收入',
  salesRevenue:'銷售收入',
  retailReturns:'零售退貨',
  salesReturns:'銷售退貨',
  procurementExpenditure:'採購支出',
  totalIncome:'收入合計',
  totalExpenditure:'支出合計',
  totalProfitLoss:'盈虧合計',
  transactionTime:'交易時間',
  dataSources:'數據來源',
  newCapitalFlow:'新建資金流水',
  editCapitalFlow:'編輯資金流水',
  selectionDateTime:'選擇日期時間',
  expenditure:'支出',
  income:'收入',
  enterAccountType:'請輸入賬目類型',
  chooseModePayment:'請選擇支付方式',
  enterAgent:'請輸入經辦人',
  enterAmount:'請輸入金額',
  nonSystemCannotJump:'非系統不能跳轉',
  selectRunningAccount:'請選擇流水賬目',
  time:'時間',
  thisWeek:'本週',
  thisMonth:'本月',
  lastMonth:'上月',
  cancellationNumber:'退單數',
  withdrawalAmount:'退單額',
  orderRecord:'訂貨記錄',
  returnRecord:'退貨記錄',
  selectDateRange:'請選擇日期範圍',
  bySalesVolumeNum:'按銷售量',
  bySalesVolume:'按銷售額',
  profit:'按利潤',
  totalSales:'銷售合計',
  salesProfit:'銷售利潤',
  ranking:'排名',
  salesVolumesNum:'銷售量',
  averageSellingPrice:'銷售均價',
  salesVolumes:'銷售額',
  profits:'利潤',
  querySingleCategory:'查詢單個分類',
  totalSaless:'總銷售額',
  chooseCategory:'請選擇分類',
  queryIndividualBrands:'查詢單個品牌',
  numberOrderingCustomers:'訂貨客户數',
  numberReturnedCustomers:'退貨客户數',
  orderStatistics:'訂單統計',
  royaltyAmount:'提成金額',
  serialNumber:'序號',
  commodityStatistics:'商品統計',
  returnAmount:'退貨額',
  customerStatistics:'客户統計',
  numberRefundCustomers:'退款客户數',
  numberVisits:'拜訪次數',
  shopNumber:'店倉編號',
  newStore:'新建店倉',
  editStore:'編輯店倉',
  enterStoreNumber:'請輸入店倉編號',
  enterNameStore:'請輸入店倉名稱',
  employeeName:'員工姓名',
  rolePermissions:'角色權限',
  employeeInformation:'員工信息',
  ascription:'歸屬',
  employeeType:'員工類型',
  internalService:'內勤',
  permissionSettings:'權限設置',
  storeAuthority:'店倉權限',
  customerRights:'客户權限',
  detailsAuthorityAuthority:'權限權限明細',
  chooseOwnership:'請選擇歸屬',
  selectTypeEmployee:'請選擇員工類型',
  roleManagement:'角色管理',
  modifyRoleName:'修改角色名稱',
  roleName:'角色名稱',
  enterRoleName:'請輸入角色名稱',
  selectRoles:'請選擇角色',
  settingAtendanceTime:'設置考勤時間',
  workShift:'上班時間',
  closingTime:'下班時間',
  settingWorkingDays:'設置工作日',
  mondays:'星期一',
  tuesdays:'星期二',
  wednesdays:'星期三',
  thursdays:'星期四',
  friday:'星期五',
  saturdays:'星期六',
  sundays:'星期天',
  holidaysAccordanceStatutoryHolidays:'按照法定假日休假',
  settingAttendanceSites:'設置考勤地點',
  attendanceRange:'考勤範圍',
  newAttendanceAddress:'新建考勤地址',
  attendancePointName:'考勤點名稱',
  attendanceAddress:'考勤地址',
  enterNameAttendancePoint:'請輸入考勤點名稱',
  clickMapSelectAttendanceAddress:'請點擊地圖選擇考勤地址',
  newSuccess:'新建成功',
  attendanceRecord:'考勤記錄',
  yearChoice:'選擇年',
  choiceMonth:'選擇月',
  situation:'情況',
  attendanceDays:'出勤天數',
  lateness:'遲到次數',
  earlyRetirementTimes:'早退次數',
  absenteeismFrequency:'曠工次數',
  chooseYear:'請選擇年份',
  chooseMonth:'請選擇月份',
  rest:'休息',
  missingCard:'缺卡',
  late:'遲到',
  leaveEarly:'早退',
  templateName:'模板名稱',
  importTemplate:'導入模板',
  printType:'打印類型',
  printPrint:'按單打印',
  continuousPrinting:'連續打印',
  tableFixing:'表頭固定',
  paperType:'紙張類型',
  threeEqualDivision:'三等分',
  twoEqualDivision:'二等分',
  fullPage:'全頁',
  wubaxiaop:'58小票',
  balingxiaop:'80小票',
  A4:'A4',
  paperWidth:'紙張寬度',
  paperHeight:'紙張高度',
  templateCode:'模板代碼',
  customPictures:'自定義圖片',
  previewTemplate:'預覽模板',
  uploadUpPicturess:'最多上傳2張圖片',
  enterpriseLOGO:'企業LOGO',
  membershipNumber:'會員編號',
  industry:'所屬行業',
  enterpriseName:'企業名稱',
  enterpriseLegalPerson:'企業法人',
  contactCellPhone:'聯繫手機',
  enterpriseAddress:'企業地址',
  fax:'傳真',
  proprietaryBrand:'自營品牌',
  sellableInventoryProcessingRules:'可售庫存處理規則',
  outgoingReduction:'出庫減',
  orderAuditReduction:'訂單審核減',
  orderReduction:'下單立減',
  outgoingReductionDescribe:'出庫減：即庫存不足時，允許商品銷售下單，允許審核訂單，待庫存充足時，出庫時扣減庫存。',
  orderAuditReductionDescribe:'訂單審核減：即庫存不足時，允許商品銷售下單，待庫存充足時，才可審核訂單。',
  orderReductionDescribe:'下單立減：即商品庫存不足時，不允許商品銷售下單。',
  startUp:'啟動',
  noStart:'不啟動',
  display:'顯示',
  noDisplay:'不顯示',
  salesmanCustomerDataRights:'業務員客户數據權限',
  salesmanCustomerDataRightsY:'啟動：即業務員或者員工只能對有客户權限的區域客户可見。',
  salesmanCustomerDataRightsN:'不啟動：即業務員或者員工對所有客户可見。',
  orderVoiceReminder:'訂單語音提醒',
  orderVoiceReminderY:'啟動：打開訂單語音提醒。',
  orderVoiceReminderN:'不啟動：關閉訂單語音提醒。',
  showShelfOutWarehouse:'出庫時顯示保質期',
  showShelfOutWarehouseY:'顯示：出庫時顯示商品剩餘保質期(需填寫商品保質期和入庫生產日期)。',
  showShelfOutWarehouseN:'不顯示：出庫時不顯示商品剩餘保質期。',
  abnormalTime:'異常時間',
  orderType:'訂單類型',
  abnormalReason:'異常原因',
  intelligence:'智能',
  orderAutomation:'訂單自動化',
  makeAppointmentWorkingHours:'預約工作時間',
  startTime:'開始時間',
  endingTime:'結束時間',
  ruleSetting:'規則設置',
  abnormalOrder:'異常訂單',
  openAll:'全部開啟',
  closeAll:'全部關閉',
  openOrderAutomation:'開啟訂單自動化，系統將自動完成以下設定任務',
  whenOrderAutomationWorking:'訂單自動化在工作狀態時，請勿關閉當前頁面，否則自動化將停止工作',
  auditOrders:'審核訂貨單',
  printOrders:'打印訂貨單',
  auditReturnBill:'審核退貨單',
  orderLower:'允許訂貨單中商品實際銷售單價低於默認銷售單價',
  orderHigher:'允許訂貨單中商品實際銷售單價高於默認銷售單價',
  returnedLower:'允許退貨單中商品實際退貨單價低於默認銷售單價',
  returnedHigher:'允許退貨單中商品實際退貨單價高於默認銷售單價',
  realPriceDefault:'商品實際單價與默認單價差額範圍≤',
  orderedExecuted:'允許訂貨單商品按照上次客户成交單價執行',
  returnExecuted:'允許退貨單商品按照上次客户成交單價執行',
  wasteSalesList:'作廢銷售單',
  singlePerson:'制單人',
  costPriceCannotEmpty:'成本價不能為空',
  warehousingCancellation:'出庫作廢',
  amountReceiptShouldGreaterUnpaidAmount:'收款金額不能大於未付金額',
  printBarcode:'打印條碼',
  noviceCourse:'新手教程',

  //登录
  sysale:'智能極速銷售系統',
  accountNumber:'賬號',
  password:'密碼',
  automaticLogon:'15天內自動登入',
  login:'登入',
  technicalSupport:'技術支持：成都川三網絡科技有限公司 | 銷售熱線: (+852) 2115 3318 | WhatsAPP:6163 2488',

  //导航栏
  commodity:'商品',
  listCommodities:'商品列表',
  listGarments:'服裝列表',
  merchandiseTime:'臨期商品',
  classifiedManagement:'分類管理',
  brandManagement:'品牌管理',
  unitManagement:'單位管理',
  specificationManagement:'規格管理',
  colorManagement:'顏色管理',
  sizeManagement:'尺碼管理',

  order:'訂單',
  orderForm:'訂貨單',
  returnOrder:'退貨單',
  swapOrder:'換貨單',

  stock:'庫存',
  inventoryStatus:'庫存狀況',
  stockStock:'商品入庫',
  stockOutStock:'商品出庫',
  inventoryAllocation:'庫存調撥',
  stockTaking:'庫存盤點',

  purchase:'採購',
  purchaseOrder:'採購單',
  purchasePlan:'採購計劃',
  supplierManagement:'供應商管理',

  customer:'客户',
  customerList:'客户列表',
  pendingCustomers:'待審客户列表',
  priceGrouping:'價格分組設置',
  customerTypeSettings:'客户類型設置',
  regionalGroupingSettings:'區域分組設置',

  cashRegister:'收銀',
  cashier:'前台收銀',
  salesRecords:'銷售記錄',
  dailyRecord:'日結記錄',
  cashRegisterSettings:'收銀設置',

  sale:'銷售',
  salesSlip:'銷售單',

  fieldPersonnel:'外勤',
  salesmanList:'業務員列表',
  taskManagement:'任務管理',
  attendanceManagement:'簽到管理',
  taskReporting:'任務上報',

  finance:'財務',
  accountType:'賬目類型',
  capitalFlow:'資金流水',

  microShop:'微店',
  bindingMicrostores:'綁定微店鋪',
  generalStoreSettings:'店鋪通用設置',
  merchandiseDisplay:'首頁商品展示',
  advertisingSpace:'首頁廣告位',
  fistributionMode:'配送方式',
  paymentMethod:'支付方式',
  myBalance:'我的餘額',

  reportForm:'報表',
  salesReport:'銷售報表',
  commodityStatement:'商品報表',
  orderReport:'訂單報表',
  performanceReport:'業績報表',

  setUp:'設置',
  storeManagement:'店倉管理',
  employeeAccountNumber:'員工賬號',
  privilegeManagement:'權限管理',
  attendanceSettings:'考勤設置',
  printSetup:'打印設置',
  companyInformation:'公司信息',
  systemSetup:'系統設置',

  //index
  productEnglish:'Sysale',
  productChinese:'',
  refresh:'刷新',
  contactCustomerService:'聯繫客服',
  visitOfficialWebsite:'訪問官網',
  returnVersion:'返回舊版',
  officialPublicNumber:'官方公眾號',
  signOut:'登出',
  twoInconsistent:'兩次輸入不一致！',
  homepage:'主頁',

  //home
  pendingDisposal:'待處理',
  productInformation:'產品信息',
  generalSituation:'經營概況',
  download:'下載',
  orderMonth:'本月訂單',
  viewReport:'查看報表',
  officialAnnouncement:'官方公告',
  returnPendingReview:'退貨待審核',
  exchangePendingReview:'換貨待審核',
  lastLogonTime:'上次登入時間',
  currentVersion:'當前版本',
  openingTime:'開通時間',
  dueTime:'到期時間',
  bindingWeChat:'綁定微信',
  totalOrdersToday:'今日訂單總數',
  totalOrderToday:'今日訂單總額',
  grossProfitTodaySales:'今日銷售毛利',
  customerArrears:'客户欠款額',
  totalInventoryCost:'庫存總成本',
  pcClient:'PC客户端',
  iosMobile:'iOS手機端',
  androidMobile:'Android手機端',
  buttonDownload:'點擊按鈕下載',
  scanCodeDownload:'掃描二維碼下載',
  simplifiedVersion:'簡體版',
  traditionalEdition:'繁體版',
  learnMore:'瞭解更多',
  remind:'提醒',
  yourService:'您的服務',
  needHelp:'如您需要幫助，請聯繫我們',
  contactInformation:'WhatsApp：61632488，微信WeChat：2441675837，Line：trenska，熱線:(+852)2115 3318',
  sort:'排序',
  ICP:'蜀ICP備16011618号',

  //router
  systemName:'智能極速銷售系統',
  addGoods:'新建商品',
  editGoods:'編輯商品',
  seeGoods:'商品詳情',
  addClothing:'新建服裝',
  editClothing:'編輯服裝',
  addOrderGoods:'新建訂貨單',
  editOrderGoods:'編輯訂貨單',
  seeOrderGoods:'查看訂貨單',
  addReturnBill:'新建退貨單',
  seeReturnBill:'查看退貨單',
  addswapOrder:'新建換貨單',
  seeswapOrder:'查看換貨單',
  inventoryDetails:'庫存明細',
  storeInventory:'店倉庫存',
  addWarehousing:'新建入庫單',
  editWarehousing:'編輯入庫單',
  seeWarehousing:'查看入庫單',
  addOutgoing:'新建出庫單',
  editOutgoing:'編輯出庫單',
  seeOutgoing:'查看出庫單',
  addAllocation:'新建調撥單',
  editAllocation:'編輯調撥單',
  seeAllocation:'查看調撥單',
  addCheck:'新建盤點單',
  editCheck:'編輯盤點單',
  seeCheck:'查看盤點單',
  addPurchase:'新建採購單',
  editPurchase:'編輯採購單',
  seePurchase:'查看採購單',
  storagePurchase:'採購入庫',
  recordsConsumption:'歷史消費記錄',
  returnRecords:'退貨記錄',
  seeSalesRecord:'查看銷售記錄',
  seeReturnRecord:'查看退貨記錄',
  paymentSettings:'支付設置',
  addSalesSlip:'新建銷售單',
  editSalesSlip:'查看銷售單',
  addTask:'新建任務',
  editTask:'編輯任務',
  seeTask:'查看任務',
  signTask:'簽到任務',
  signSituation:'簽到情況',
  monthlySummary:'月度彙總',
  addSignTask:'新建簽到任務',
  editSignTask:'編輯簽到任務',
  seeSignTask:'查看簽到任務',
  displayInspection:'陳列檢查',
  photoRecord:'拍照記錄',
  stockReport:'庫存上報',
  classifiedReport:'分類報表',
  brandReport:'品牌報表',
  seeAchievement:'查看業績詳情',
  salesmanAccount:'業務員賬號',
  addEmployee:'新建員工',
  editEmployee:'編輯員工',
  attendanceSummary:'考勤彙總',
  orderTemplate:'訂貨單模板',
  warehousingTemplate:'入庫單模板',
  exitTemplate:'出庫單模板',
  callTemplate:'調撥單模板',
  purchasingTemplate:'採購單模板',
  cashTemplate:'收銀單模板',
}



// WEBPACK FOOTER //
// ./src/assets/js/zh-hk.js